/**
 * "Trouble signing in? Chat with us" under the login, signup and code
 * screens (2026-10-16). Opens Intercom as a visitor, no account needed.
 * There's no floating bubble on purpose: on a phone it sits on top of the
 * main button.
 */
import { openVisitorChat } from '../lib/intercom';
import { phQuestionOpened } from '../lib/posthog';
import '@styles/components/auth-help.css';

type Props = {
  /** login, signup, verify, no_account. Goes to PostHog as the source. */
  page: string;
  /** Whatever they typed, so whoever answers knows who it is. */
  email?: string;
  label?: string;
};

export default function AuthHelp({ page, email, label = 'Trouble signing in?' }: Props) {
  const open = () => {
    const typed = email?.trim();
    phQuestionOpened({ source: `auth_${page}` });
    openVisitorChat(
      typed
        ? `Hi, I'm having trouble signing in with ${typed}. `
        : "Hi, I'm having trouble signing in. ",
    );
  };

  return (
    <p className="auth-help">
      {label}{' '}
      <button type="button" className="auth-help-btn" onClick={open}>
        Chat with us
      </button>
    </p>
  );
}

/** Small "Last used" pill, placed on the Google button or the email box. */
export function LastUsedTag() {
  return <span className="last-used-tag">Last used</span>;
}
